export const formResetDelay = 500;
export const programLevelAll = 1;
